import React from 'react';
import SatInput from '@components/common/satUI/SatInput';
import SatModal from '@components/common/satUI/SatModal';
import InputInsuranceCategoryTable from './InputInsuranceCategoryTable';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import { isEmptyString } from '@common/utils';

const InputInsuranceCategory = ({ value, isErrorVisible, onChange }) => {
  const {
    isOn: isShowModal,
    on: showModal,
    off: hideModal,
  } = $hooks.useToggler();

  return (
    <>
      <SatInput noFocus value={value} onClick={showModal} />
      <SatValidationErrMsg
        type="error"
        visible={isErrorVisible && isEmptyString(value)}
        message="값을 입력해주세요."
      />

      <SatModal
        isPortal
        isScroll
        wide
        type="info"
        visible={isShowModal}
        setVisible={hideModal}
      >
        <header className="modal-header">
          <h3 className="layer-tit2">보험목적(보험종류)</h3>
        </header>
        <button
          type="button"
          className="btn-layer-close modal-close"
          onClick={hideModal}
        >
          닫기
        </button>

        <div className="cont">
          <div className="insu-box">
            <ul className="dot-type type-m">
              <li>
                <span className="red">
                  신규계약과 유사보험군이 상이할 경우에는 타사 기존계약 작성
                  대상이 아닙니다.
                </span>
                <br /> 예시)신규계약이 '종신보험'인 경우, 2006. 6월 이전 타사에
                가입된 보험계약이 '연금보험'인 경우는 작성대상이 아닙니다.
              </li>
              <li>
                신규계약과{' '}
                <span className="red">유사보험군이 동일한 보험종류만</span> 타사
                기존계약을 입력하시기 바랍니다.
              </li>
            </ul>

            <InputInsuranceCategoryTable
              isInput
              value={value}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="layer-footer">
          <button
            type="button"
            className="btn-s blue btn-wide modal-close"
            onClick={hideModal}
          >
            저장
          </button>
        </div>
      </SatModal>
    </>
  );
};

export default InputInsuranceCategory;
